__turbopack_context__.v({
  "iconWrapper": "TrafficSectionItem-module-scss-module__zF4roq__iconWrapper",
  "section": "TrafficSectionItem-module-scss-module__zF4roq__section",
  "timestamp": "TrafficSectionItem-module-scss-module__zF4roq__timestamp",
  "title": "TrafficSectionItem-module-scss-module__zF4roq__title",
  "wrapper": "TrafficSectionItem-module-scss-module__zF4roq__wrapper",
});
